import { FC, RefObject, useRef } from 'react';
import { Swiper } from 'swiper/types';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import galleryThumbnailsCss from '../../../assets/gallery/gallery-thumbnails.module.scss';

type PropsType = {
  isVisible: boolean;
  setProgress: (progress: number) => void;
  refThumbsInstance: RefObject<Swiper>,
};

const BtnPrev: FC<PropsType> = ({
  isVisible,
  setProgress,
  refThumbsInstance,
}) => {
  const refButton = useRef<HTMLButtonElement>(null);

  const handlerClick = (): void => {
    refThumbsInstance.current.slidePrev();
    setProgress(refThumbsInstance.current.progress);
  };

  return (
    <CSSTransition
      nodeRef={refButton}
      in={isVisible}
      timeout={300}
      classNames={{
        enter: galleryThumbnailsCss.galleryThumbs__btnPrev_enter,
        enterActive: galleryThumbnailsCss.galleryThumbs__btnPrev_enterActive,
        exit: galleryThumbnailsCss.galleryThumbs__btnPrev_exit,
        exitActive: galleryThumbnailsCss.galleryThumbs__btnPrev_exitActive,
      }}
    >
      <Button
        ref={refButton}
        variant={ButtonVariant.black}
        additionalClassName={classNames(
          galleryThumbnailsCss.galleryThumbs__btnPrev,
          { [galleryThumbnailsCss.galleryThumbs__btnPrev_visible]: isVisible },
          { [galleryThumbnailsCss.galleryThumbs__btnPrev_hidden]: !isVisible },
        )}
        onClick={handlerClick}
        aria-label="Prev"
      />
    </CSSTransition>
  );
};

export { BtnPrev };
